import { Route, Routes } from 'react-router-dom';
import { Suspense } from 'react';
import { PageLoader } from 'shared/ui/PageLoader/PageLoader';
import { ShopLayout } from 'app/layouts/ShopLayout';
import { MainLayout } from 'app/layouts/MainLayout';
import { MainPage } from 'pages/MainPage';
import { MonologuePage } from 'pages/MonologuePage';
import { RecoveryPage } from 'pages/RecoveryPage';
import { AuthPage } from 'pages/AuthPage';
import { CharacterSelectPage } from 'pages/CharacterSelectPage';
import { ShopPage } from 'pages/ShopPage';
import { HistoryPage } from 'pages/HistoryPage';
import { ProfessionChoicePage } from 'pages/ProfessionChoicePage';
import { InvestmentsPage } from 'pages/InvestmentsPage';
import { ContributionPage } from 'pages/ContributionPage';
import { FinancePage } from 'pages/FinancePage';
import { NSGPage } from 'pages/NSGPage';
import { PlotPage } from 'pages/PlotPage';
import { CartPage } from 'pages/CartPage';
import { PolicyPage } from 'pages/PolicyPage';
// import { ProductPage } from 'pages/ProductPage';
import { StartPage } from 'pages/StartPage';
import { WelcomeScreen } from 'pages/WelcomeScreen';

const AppRouter = () => (
    <Suspense fallback={<PageLoader />}>
        <Routes>
            <Route path="/" element={<MainLayout />}>
                <Route path="auth" element={<AuthPage />} />
                <Route path="avatar" element={<CharacterSelectPage />} />
                <Route path="password-reset/:token" element={<RecoveryPage />} />
                <Route path="monologue" element={<MonologuePage />} />
                <Route path="plot" element={<PlotPage />} />
                <Route path="profession" element={<ProfessionChoicePage />} />
                <Route path="start" element={<StartPage />} />
                <Route path="welcome" element={<WelcomeScreen />} />
                {/* <Route index element={<CharacterSelectPage />} /> */}
                <Route path="*" element={<AuthPage />} />
            </Route>
            <Route path="/" element={<ShopLayout />}>
                <Route index element={<MainPage />} />
                <Route path="investments" element={<InvestmentsPage />} />
                <Route path="contribution" element={<ContributionPage />} />
                <Route path="nsg" element={<NSGPage />} />
                <Route path="shop" element={<ShopPage />} />
                <Route path="history" element={<HistoryPage />} />
                <Route path="finance" element={<FinancePage />} />
                <Route path="cart" element={<CartPage />} />
                <Route path="/finance/policy/:name" element={<PolicyPage />} />
            </Route>
        </Routes>
    </Suspense>
);
export default AppRouter;
